module.exports = __webpack_public_path__ + "static/img/clothing_11.4f0d76d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/inventory/stickers/clothing_11.png
// module id = byci
// module chunks = 0